const ZH_TW = 'zh-TW';
const ZH_CN = 'zh-CN';
const EN_US = 'en-US';
const DefaultLang = 'en';
const SupportedLangs = ['en', 'cn', 'tw'];

const LangLocaleMap = { en: 'en-US', tw: 'zh-TW', cn: 'zh-CN' };

const LocaleLangMap = Object.entries(LangLocaleMap).reduce(
  (acc, [key, value]) => {
    acc[value] = key;
    return acc;
  },
  {},
);

const HrefLang = {
  en: 'en',
  tw: 'zh-Hant',
  cn: 'zh-Hans',
};

const LangMenu = [
  { lang: 'en', text: 'English' },
  { lang: 'tw', text: '繁體中文' },
  { lang: 'cn', text: '简体中文' },
];

module.exports = {
  DefaultLang,
  SupportedLangs,
  LangLocaleMap,
  LocaleLangMap,
  HrefLang,
  LangMenu,
  ZH_TW,
  ZH_CN,
  EN_US,
};
